import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EndpointKey } from '../../http/EndpointKey';
import Logger from '../../lib/Logger';
import { retryEndpoint } from '../../store/http-responses/action-creators';
import { useTracker } from '../../tracking/useTracker';
import { getIsVerificationExpired, getIsNewUser, getIsCompleteVerificationCompleteValue } from '../../store/app/selectors';
import { isOAuthSignup } from '../../app/verificationTypeSelectors';
import { TrackWhen, useExperiment } from '../../experiments/useExperiment';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
const LOG = Logger.getLogger('useRecaptchaChallenge');
export const useRecaptchaChallenge = () => {
  const Tracker = useTracker();
  const dispatch = useDispatch();
  const [isChallengeResolved, setIsChallengeResolved] = useState(false);
  const completeVerificationIsNotFinished = !useSelector(getIsCompleteVerificationCompleteValue);
  const isVerificationExpired = useSelector(getIsVerificationExpired);
  const isNewUser = useSelector(getIsNewUser);
  const getIsOAuthSignup = useSelector(isOAuthSignup);
  const {
    isAssignedToSpecificVariant: isAssignedToSpecificVariantACQ173
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.never);
  const isAssignedToACQ173VariantB = isAssignedToSpecificVariantACQ173(ExperimentParameterGroup.Variant_B);
  useEffect(() => {
    Tracker.signupInteraction('creation-error-recaptcha-fallback');
  });
  const onClick = () => {
    if (isAssignedToACQ173VariantB && isNewUser && !getIsOAuthSignup && (completeVerificationIsNotFinished || isVerificationExpired)) {
      dispatch(retryEndpoint(EndpointKey.InitiateVerification, 2200));
    } else {
      dispatch(retryEndpoint(EndpointKey.Signup, 2200));
    }
  };
  const onResolvedHandler = useCallback(() => {
    setIsChallengeResolved(true);
  }, [setIsChallengeResolved]);
  const onExpiredHandler = useCallback(() => {
    setIsChallengeResolved(false);
  }, [setIsChallengeResolved]);
  const onErrorHandler = useCallback(error => {
    LOG.error(`Recaptcha returned an error: ${error}`);
    setIsChallengeResolved(false);
  }, [setIsChallengeResolved]);
  return {
    isChallengeResolved,
    onClick,
    onErrorHandler,
    onExpiredHandler,
    onResolvedHandler
  };
};